import { useCallback, useState } from 'react';
import { startOfWeek, getWeek, addWeeks, subWeeks, subMonths, addMonths } from 'date-fns';
import { Buttons, Cards, Dates, Header, Icon, Leftarrow, Leftheader, Main, Rightheader } from './styles';
import SVGIcon from '../../../../../assets/images/svg/SVGIcon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { createNewComment, updateTaskDetails } from '../../../../../services/taskServices';
import Monthview from '../../../../../component/monthView';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { isEmpty } from '../../../../../helpers/common';
import { useHotkeys } from 'react-hotkeys-hook';
import ModalCustom from '../../../../../component/models/modal';
import DeleteModal from '../../../../../component/models/deleteModel';
import { captureException } from '../../../../../services/logService';
import { rootStore } from '../../../../../mobx/rootStore';
import { WeekDayTask } from '../../../../../services/mobxTaskFilterService';
import WeekViewCard from '../../../../../component/weekviewCard';
import { TaskModel } from '../../../../../mobx/models/task';
import { DataCommentsInterface } from '../../../../../interfaces/TaskInterface';
import { COMMENT_TYPE } from '../../../../../global/constants';
import { trackAnalyticActivity } from '../../../../../services/analyticsService';
import { TASK_ANALYTICS } from '../../../../../global/analyticsConstants';
import CreateTaskModalV2 from '../../../../../component/models/createTaskModal/createTaskModalV2';

// eslint-disable-next-line @typescript-eslint/no-redeclare
declare type DropResult = typeof import('react-beautiful-dnd');

interface Props {
  propsLoading: boolean;
  loadData: () => void;
  loadWeekWiseTasks: () => void;
  weekWiseTasks: WeekDayTask[];
  currentDate: Date;
}

function CalendarView(props: Props) {
  const { loadData, loadWeekWiseTasks, weekWiseTasks, currentDate = new Date() } = props;
  const dispatch = useDispatch();

  // For display monthView functionality manage below state
  const [startDayOfWeek, setStartDayOfWeek] = useState(moment(startOfWeek(new Date(), { weekStartsOn: 1 })));
  const [isOpenFromShortcut, setIsOpenFromShortcut] = useState(false);
  const [selectedItem, setSelectedItem] = useState<TaskModel>();
  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  //Mobx store variables
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;

  // For monthView variable manage static false as we ha
  const monthView = false;

  const close = useCallback(() => {
    setIsOpenFromShortcut(false);
    setOpen(false);
    rootStore.taskStore.createTaskInput.clear();
  }, []);

  // const loadTasksData = useCallback(async () => {
  //   if (!isEmpty(workspaceDetails?.id)) {
  //     await dispatch(loadProjectTasks(currentProject?.id));
  //     loadWeekWiseTasks(moment(startOfWeek(currentDate, { weekStartsOn: 1 })).format('YYYY-MM-DD'));
  //     loadData();
  //   }
  // }, [currentDate, currentProject?.id, dispatch, loadData, loadWeekWiseTasks, workspaceDetails?.id]);

  // useEffect(() => {
  //   loadWeekWiseTasks(moment(startOfWeek(new Date(), { weekStartsOn: 1 })).format('YYYY-MM-DD'));
  // }, [loadWeekWiseTasks]);

  const onClickToday = useCallback(() => {
    const startDayOfWeekDate = moment(startOfWeek(new Date(), { weekStartsOn: 1 }));
    setStartDayOfWeek(moment(startDayOfWeekDate));
    currentProject?.setStartOfTheWeek(startDayOfWeekDate.toDate());
    loadWeekWiseTasks();
  }, [loadWeekWiseTasks, currentProject]);

  const isCurrentWeek = (): boolean => {
    const startOfWeekDisplayed = moment(startDayOfWeek);
    const endOfWeekDisplayed = moment(startOfWeekDisplayed).add(6, 'days');
    const today = moment();
    return today.isBetween(startOfWeekDisplayed, endOfWeekDisplayed, 'day', '[]');
  };

  useHotkeys('c', () => {
    setTimeout(() => {
      setIsOpenFromShortcut(true);
      setOpen(true);
      rootStore.taskStore.createTaskInput.setProject(currentProject?.id || '');
    }, 100);
  });

  // const handleTaskOpen = (flag: boolean) => {
  //   setTaskDropdown(flag);
  // };

  const changeWeekHandle = (btnType: string, isMonthView: boolean) => {
    const currentMonth = currentDate;
    if (!isMonthView) {
      let updatedMonth, updatedWeek;
      if (btnType === 'prev') {
        updatedMonth = subWeeks(currentMonth, 1);
        updatedWeek = getWeek(subWeeks(currentMonth, 1));
      } else if (btnType === 'next') {
        updatedMonth = addWeeks(currentMonth, 1);
        updatedWeek = getWeek(addWeeks(currentMonth, 1));
      }
      if (updatedMonth && updatedWeek) {
        const startDayOfWeekDate = moment(startOfWeek(updatedMonth, { weekStartsOn: 1 }));
        setStartDayOfWeek(startDayOfWeekDate);
        currentProject?.setStartOfTheWeek(startDayOfWeekDate.toDate());
        loadWeekWiseTasks();
      }
    } else {
      let updatedMonth;
      if (btnType === 'prev') {
        updatedMonth = subMonths(currentMonth, 1);
      } else if (btnType === 'next') {
        updatedMonth = addMonths(currentMonth, 1);
      }
      if (updatedMonth) {
        const startDayOfWeekDate = moment(startOfWeek(updatedMonth, { weekStartsOn: 1 }));
        setStartDayOfWeek(startDayOfWeekDate);
        currentProject?.setStartOfTheWeek(startDayOfWeekDate.toDate());
      }
    }
  };

  const onClickEdit = useCallback(async (task: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(task);
    setOpen(true);
  }, []);

  const onClickClone = useCallback(async (task: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(task);
    rootStore.taskStore.createTaskInput.setDueDate(null);
    rootStore.taskStore.createTaskInput.setId(undefined);
    setOpen(true);
  }, []);

  const OpenModal = (item: TaskModel) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const Cancel = () => {
    setIsModalOpen(false);
    setSelectedItem(undefined);
  };

  const deleteTask = useCallback(
    async (task: TaskModel) => {
      try {
        setDeleteLoading(true);
        const payloadTask = { isArchived: true, projectId: task?.projectId };
        const response = await dispatch(updateTaskDetails(task?.id, payloadTask));
        setIsModalOpen(false);
        setSelectedItem(undefined);
        if (response) {
          loadData();
        }
      } catch (error) {
        captureException(error);
        console.log('error', error);
      } finally {
        setDeleteLoading(false);
      }
    },
    [dispatch, loadData]
  );

  const renderDays = useCallback(() => {
    return weekWiseTasks.map((item, i) => {
      return (
        <WeekViewCard
          key={i}
          loadData={loadWeekWiseTasks}
          dayName={item.dayName}
          date={item.date}
          tasks={item.tasks || []}
          completedTasks={item.completedTasks || []}
          dateString={item.dateString}
          onClickEdit={onClickEdit}
          onClickClone={onClickClone}
          OpenModal={OpenModal}
        />
      );
    });
  }, [loadWeekWiseTasks, onClickClone, onClickEdit, weekWiseTasks]);

  // const onClickMonthWeekView = useCallback((value: boolean) => {
  //   setMonthView(value);
  //   setTaskDropdown(false);
  // }, []);

  const onDragEnd = useCallback(
    async (result: DropResult) => {
      if (!result.destination) {
        return;
      }
      const sourceDueDate = result.source.droppableId;
      const destinationDueDate = result.destination.droppableId;
      if (sourceDueDate !== destinationDueDate) {
        const dayIndex = weekWiseTasks?.findIndex((item) => item?.dateString === sourceDueDate);
        if (dayIndex === -1) return;
        const day = weekWiseTasks[dayIndex];
        const taskIndex = day?.tasks?.findIndex((item) => item?.id === result.draggableId);
        if (taskIndex === -1) return;
        const task = day?.tasks[taskIndex];
        const updatedDate = moment(destinationDueDate).utc().format();
        task.setDueDate(new Date(destinationDueDate));
        const payload = {
          previousDueDate: task?.dueDate,
          dueDate: updatedDate
        };
        const payloadTask = { dueDate: payload?.dueDate, projectId: task?.projectId };
        const response = await dispatch(updateTaskDetails(task?.id, payloadTask));
        const commentPayload: DataCommentsInterface = {
          Type: COMMENT_TYPE.SET_DUE_DATE,
          DueDate: updatedDate
        };
        if (!isEmpty(payload?.previousDueDate)) {
          commentPayload['Type'] = COMMENT_TYPE.CHANGE_DUE_DATE;
          commentPayload['PreviousDueDate'] = payload?.previousDueDate?.toISOString();
        }
        currentProject?.setStartOfTheWeek(moment(destinationDueDate).toDate());
        const resultRes = await dispatch(createNewComment(task?.id, commentPayload));
        if (response && resultRes) {
          if (commentPayload.Type === COMMENT_TYPE.SET_DUE_DATE) trackAnalyticActivity(TASK_ANALYTICS.SCHEDULED);
          else trackAnalyticActivity(TASK_ANALYTICS.RESCHEDULED);
          loadWeekWiseTasks();
        }
      }
    },
    [weekWiseTasks, dispatch, currentProject, loadWeekWiseTasks]
  );

  return (
    <div>
      <Main>
        <Header>
          <Leftheader>
            {/* Week view */}
            {monthView ? (
              <Dates>{moment(currentDate).format('MMM')} 2024</Dates>
            ) : (
              <Dates>
                {startDayOfWeek.format('DD MMM')} - {moment(startDayOfWeek).add(6, 'days').format('DD MMM')},{' '}
                {currentDate?.getFullYear()}
              </Dates>
            )}
            {/* Month view */}
            <Icon>
              <Leftarrow onClick={() => changeWeekHandle('prev', monthView)}>
                <SVGIcon name='left-arrow-icon' width='17' height='17' viewBox='0 0 17 17' className='arrow-icon' />
              </Leftarrow>
              <Leftarrow onClick={() => changeWeekHandle('next', monthView)}>
                <SVGIcon
                  name='right-arrow-icon'
                  width='17'
                  height='17'
                  viewBox='0 0 17 17'
                  className='right-arrow-icon'
                  stroke='var(--text-secondary)'
                />
              </Leftarrow>
            </Icon>
          </Leftheader>
          <Rightheader>
            {!isCurrentWeek() && <Buttons onClick={onClickToday}>Today</Buttons>}
            {/* calander view in weekview monthview dropdown hide for now */}
            {/* <Dropdown
              trigger={['click']}
              onOpenChange={handleTaskOpen}
              placement='bottomRight'
              dropdownRender={() => (
                <>
                  <Viewdropdown>
                    <Menu className='menuStyle'>
                      <Menu.Item className='menuitem' onClick={() => onClickMonthWeekView(false)}>
                        Week view
                      </Menu.Item>
                      <Menu.Item className='menuitem' onClick={() => onClickMonthWeekView(true)}>
                        Month view
                      </Menu.Item>
                    </Menu>
                  </Viewdropdown>
                </>
              )}>
              <Status>
                <p>{monthView ? 'Month view' : 'Week view'}</p>
                <SVGIcon
                  name='dropdown-icon'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  className={taskDropdown ? 'dropdown-icon fill-color' : 'fill-color'}
                />
              </Status>
            </Dropdown> */}
          </Rightheader>
        </Header>
        {/* Week view and Month view */}
        {monthView ? (
          <Monthview currentMonth={currentDate} monthData={[]} />
        ) : (
          <DragDropContext onDragEnd={onDragEnd}>
            <Cards>{renderDays()}</Cards>
          </DragDropContext>
        )}
        <ModalCustom open={open} onClose={close} isCreateTask={true}>
          <CreateTaskModalV2 loadData={loadWeekWiseTasks} onCancel={close} isFromShortcut={isOpenFromShortcut} />
        </ModalCustom>
        <ModalCustom open={isModalOpen} onClose={Cancel} width={334}>
          <DeleteModal
            onClose={Cancel}
            onOk={() => selectedItem && deleteTask(selectedItem)}
            loading={deleteLoading}
            modalTitle='Delete Task?'
            description='Are you sure you want to delete this task?'
          />
        </ModalCustom>
      </Main>
    </div>
  );
}

export default CalendarView;
